import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CadastreHeader from "../headers/cadastre.header";
import BenefitCadastreForm from "./forms/benefit.cadastre.form";
import BenefitCadastreList from "./lists/benefit.cadastre.list";
import { useTranslateContext } from "../../contexts/translate.context";

export interface IBenefitCadastreProps {
    viewOnly?: boolean
}

export const BenefitCadastre: React.FC<IBenefitCadastreProps> = (props: IBenefitCadastreProps) => {

    const { benefitId } = useParams();
    const { display } = useTranslateContext();

    const title = 'Beneficiante';
    const description = '';

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ recordSelected, setRecordSelected ] = useState({ param : benefitId || '', selected : ((benefitId === 'new') || (benefitId === '0') || (!Number.isNaN(Number.parseInt(benefitId ||'')))) });

    function setSelected(isRecord: boolean, recordId: string) {
        setRecordSelected({ param : recordId, selected : isRecord });
    }

    async function initialize() {
    }
    
    useEffect(() => {
        if (!isLoading && !reloadPage) {
            initialize();
            setLoading(true);
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []);

    
    return (
        <div className="page">
            <CadastreHeader title="Beneficiantes" description={description} />
            {(recordSelected.selected) ? (
                <BenefitCadastreForm 
                    title={title}
                    benefitId={recordSelected.param}
                    setRecord={(event: any) => {
                        event.preventDefault();

                        setSelected(false, '0');
                    }}
                    viewOnly={props.viewOnly}
                />
            ) : (
                <BenefitCadastreList
                    title={title}
                    setRecord={(event: any, recordId: string) => { 
                        event.preventDefault();
        
                        setSelected(true, recordId); 
                    }}
                    viewOnly={props.viewOnly}
                />
            )}
        </div>
    )
}

export default BenefitCadastre;
